import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
    DistributionPartnerInformationService,
    DPIMInfoQueryParametersHelperService,
    GetDPIMQueryParameters
} from '@nationwide/internet-servicing-dpim-requests';
import { DpimRoleInfoResponse } from '../../../tpi-models/dpim';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ECIF } from '../../../CONSTANTS/tpi-ecif-constants';
import { EcifService } from '../../../service/ecif.service';
import { ECIFResponse } from '../../../tpi-models/general/ecifResponse';
@Injectable()
export class DistributionPartnerIndividualInfoService {
    private distributionPartnerInformationService = inject(DistributionPartnerInformationService);
    private dPIMInfoQueryParametersHelperService = inject(DPIMInfoQueryParametersHelperService);
    private ecifService = inject(EcifService);

    fetchDistributionPartnerIndividualInfo(policyNumber: string, euaToken: string): Observable<DpimRoleInfoResponse> {
        return this.ecifService.getEcifPolicyAgreement(policyNumber, euaToken).pipe(
            switchMap((ecifResponse: ECIFResponse): Observable<any> => {
                let agentStateCode: string;
                let agentNumber: string;
                let producerType: string;
                if (ecifResponse.relatedDistributionPartners) {
                    for (const relatedDistributionPartner of ecifResponse.relatedDistributionPartners) {
                        if (relatedDistributionPartner.distributionPartnerType === ECIF.PRODUCER_VALUES.PRODUCER) {
                            agentNumber = relatedDistributionPartner.externalIdentifier;
                        }
                        if (
                            relatedDistributionPartner.distributionPartnerType ===
                            ECIF.PRODUCER_VALUES.RESIDENT_PRODUCER &&
                            relatedDistributionPartner.roleDistributionChannel
                        ) {
                            producerType =
                                relatedDistributionPartner.roleDistributionChannel ===
                                    ECIF.PRODUCER_VALUES.INDEPENDENT_CHANNEL_AGENT ? ECIF.PRODUCER_VALUES.AMF : ECIF.PRODUCER_VALUES.PDS;
                        }

                        agentStateCode = ecifResponse.relatedDistributionPartners[0].licenseState;
                    }
                }
                const queryParams: GetDPIMQueryParameters = this.dPIMInfoQueryParametersHelperService.retrieveDPIMQueryParams(agentNumber, agentStateCode);
                return this.distributionPartnerInformationService.retrieveDistributionPartnerRoleInfo({
                    accessToken: euaToken,
                    agentNumber: queryParams?.agentNumber,
                    query: this.generateQueryString(producerType, queryParams)
                }).pipe(catchError((error: HttpErrorResponse) => of(error)));
            })
        );
    }

    generateQueryString(producerType: string, queryParams: GetDPIMQueryParameters): string {
        const includeSubRoleContractDataValue = producerType === ECIF.PRODUCER_VALUES.AMF ? 'true' : 'false';
        return `legacyIdentifierType=${queryParams.legacyIdentifierType}&legacyAdministrativeSystem=${queryParams.legacyAdministrativeSystem}&filterLicenseSummaries=true&includeSubRoleContractData=${includeSubRoleContractDataValue}&client_id=${environment.authorize.client_id}`;
    }
}